/*
  Edition status (snippets/block-edition-status.liquid): when the selected variant changes, show its stage, fill and
  status. Each block carries every variant's "tone|fill|status" in its JSON, so there's nothing to work out here.
*/
const wired = new Set()

function show(block, variantId) {
  let lines
  try {
    lines = JSON.parse(block.querySelector('[data-sbs-edition-lines]').textContent)
  } catch {
    return
  }
  const line = lines[String(variantId)] || ''
  block.hidden = !line
  if (!line) return
  const [tone, fill, ...rest] = line.split('|')
  block.dataset.tone = tone
  block.style.setProperty('--sbs-edition-fill', `${Number(fill) || 0}%`)
  block.querySelector('[data-sbs-edition-status]').textContent = rest.join('|')
}

function wire() {
  document.querySelectorAll('.sbs-edition[data-section-id]').forEach((block) => {
    const key = `${block.dataset.sectionId}:${block.dataset.productId}`
    if (wired.has(key)) return
    wired.add(key)
    document.addEventListener(`variant:change:${key}`, ({ detail }) => {
      const id = detail && detail.variant && detail.variant.id
      if (!id) return
      document
        .querySelectorAll(`.sbs-edition[data-section-id="${block.dataset.sectionId}"][data-product-id="${block.dataset.productId}"]`)
        .forEach((each) => show(each, id))
    })
  })
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire)
else wire()
